import type { FollowRequestStatus } from '@/api/user/types/FollowRequest';

export enum AlertTypeEnum {
  groupWorkout = 'group_workout',
  groupInvite = 'group_invite',
  groupWorkoutDone = 'group_workout_done',
  post = 'post',
  comment = 'comment',
  reaction = 'reaction',
  workout = 'workout',
  chat = 'chat',
  follow = 'follow',
  following = 'following',
}

interface AlertData {
  groupId?: string;
  userId: string;
  /** Post owner. Required for Post View; distinct from actor `userId`. */
  authorId?: string;
  postId?: string;
  commentId?: string;
  workoutEventId?: string;
  chatId?: string;
  fullName?: string;
  status?: FollowRequestStatus;
}

export interface Alert {
  id: string;
  type: AlertTypeEnum;
  imageUrl?: string;
  title: string;
  body: string;
  createdAt: string;
  readAt?: string;
  data: AlertData;
}
